import { memo, useCallback, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAsyncDebounce } from "react-table";
import { useInterval } from "../../../utils";
import { Link, useSnackbar } from "../../ui";

import styles from "./style.module.scss";

const reload = () => window.location.reload();

export const AppVersionChecker = memo(() => {
  const location = useLocation();
  const versionRef = useRef("");
  const { push } = useSnackbar();

  const checkVersion = useCallback(async () => {
    if (!document.hidden) {
      const response = await fetch(`/?v=${Date.now()}`, {
        mode: "cors",
        method: "HEAD",
      });

      const lastModified = response.headers.get("last-modified");

      if (!versionRef.current) {
        versionRef.current = lastModified ?? "";
      } else if (versionRef.current !== lastModified) {
        push({
          key: "app-update",
          type: "info",
          title: "New version available",
          message: (
            <div className={styles.link}>
              {`You could `}
              <Link linkType="s" component="button" type="button" onClick={reload}>reload</Link>
              {` the app to get the newest features`}
            </div>
          ),
          autoClose: false,
        });
      }
    }
  }, [ push ]);

  const debouncedCheckVersion = useAsyncDebounce(checkVersion, 2 * 60 * 1000);

  useInterval(debouncedCheckVersion, 10 * 60 * 1000); //every 10 minutes
  useEffect(() => {debouncedCheckVersion();}, [ location, debouncedCheckVersion ]); // on location changed
  useEffect(() => {
    document.addEventListener("visibilitychange", checkVersion);
    return () => document.removeEventListener("visibilitychange", checkVersion);
  }, [ checkVersion ]); // on visibility changed

  return null;
});

export default AppVersionChecker;
